import styles from './UIGameRotateDeviceDialog.module.scss'
import React from 'react'
import {Dialog} from '../../common/Dialog'
import {T} from '../../common/T'
import IconRotatePhone from '@static/images/icon_rotate_phone.png'

export function UIGameRotateDeviceDialog() {
    return (
        <Dialog.Root>
            <Dialog.Portal>
                <Dialog.Backdrop className={styles.rotateDeviceBackdrop} />
                <Dialog.Popup className={styles.rotateDevicePopup}>
                    <Dialog.Title>
                        <T id="strings:popups.rotateDevice.title" />
                    </Dialog.Title>
                    <Dialog.Description className={styles.rotateDeviceDescription}>
                        <div className={styles.rotateDeviceImageContainer}>
                            <img src={IconRotatePhone} className={styles.rotateDeviceImage} />
                        </div>
                        <T id="strings:popups.rotateDevice.description" />
                    </Dialog.Description>
                </Dialog.Popup>
            </Dialog.Portal>
        </Dialog.Root>
    )
}
